import { extend } from 'vee-validate';
import { confirmed, email, required } from 'vee-validate/dist/rules';

export default (function initValidation(){
  extend('required', {
    ...required,
    message: 'This question requires a response.'
  });

  extend('requiredNumeric', {
    ...required,
    message: 'This question requires a numeric response.'
  });

  extend('requiredText', {
    ...required,
    message: 'The current selection requires a text response.'
  });

  extend('requiredField', {
    ...required,
    message: 'This field is required.'
  })

  extend('requiredCode', {
    ...required,
    message: 'Please enter an access code.'
  });

  extend('requiredUsername', {
    ...required,
    message: 'Please enter your username.'
  });

  extend('requiredPassword', {
    ...required,
    message: 'Please enter a password.'
  });

  extend('requiredReport', {
    ...required,
    message: 'Please select a report'
  })

  extend('requiredEmail', {
    ...required,
    message: 'Please enter your email.'
  })

  extend('email', {
    ...email,
    message: 'Please enter a properly formatted email.'
  })

  extend('confirmed', {
    ...confirmed,
    message: 'The emails do not match.'
  })

  extend('requiredPassword', {
    ...required,
    message: 'Please enter your password.'
  })

  extend('passwordConfirmed', {
    ...confirmed,
    message: 'The passwords do not match.'
  })

  extend('requiredOptionText', {
    params: ['params'],
    validate (value, {params}) {
      let response = params.question.responses.find(response => response.hspResponseId === value);
      let textVal = ['', null, undefined].indexOf(params.stateResponseTextValue) === -1 ? params.stateResponseTextValue : '';

      if([2,3].indexOf(response.hspResponseTypeId) >= 0) {
        if(textVal.trim().length === 0) {
          return false;
        }
      }

      return true;
    },
    message: 'The current selection requires a text response.'
  });

  extend('cbRequired', {
    params: ['params'],
    validate: (value, {params}) => {
      let msg = true;
      let textVal = ['', null, undefined].indexOf(params.stateResponseTextValue) === -1 ? params.stateResponseTextValue : '';

      if(Array.isArray(params.stateResponse) && params.stateResponse.length) {
        params.stateResponse.forEach(response => {
          let questionResponse = params.question.responses.find(questionResponse => questionResponse.hspResponseId === response);

          if([2,3].indexOf(questionResponse.hspResponseTypeId) >= 0) {
            if(textVal.trim().length === 0) {
              msg = 'The current selection requires a text response.';
            }
          }

        });

        return msg;
      }

      return 'This question requires a response.';
    }
  });

  extend('rangeValid', {
    params: ['target'],
    validate(value, { target }) {
      let yr1 = new Date(target);
      let yr2 = new Date(value);

      return yr1 <= yr2;
    },
    message: 'Please select a valid range.'
  })

  extend('min', {
    params: ['min'],
    validate: (value, {min}) => {
      if(value >= min) {
        return true;
      }
      else {
        return `Please enter a value greater than or equal to ${min}`;
      }
    }
  });

  extend('max', {
    params: ['max'],
    validate: (value, {max}) => {
      if(value <= max) {
        return true;
      }
      else {
        return `Please enter a value less than or equal to ${max}`;
      }
    }
  });

  extend('minMax', {
    params: ['min', 'max'],
    validate: (value, {min, max}) => {
      if (value >= min && value <= max) {
        return true;
      }
      else {
        return `Please enter a value between ${min} and ${max}`;
      }
    },
    message: 'Please enter a value between 18 and 50.'
  });

}())
